export default __webpack_public_path__ + "static/media/horse-intro.3368e04b.png";